module.exports = __webpack_public_path__ + "static/media/edit.b9ca465e.png";